document.addEventListener('DOMContentLoaded', () => {
  initCarousels();
  initCollapses();
});

function initCarousels() {
  document.querySelectorAll('.carousel').forEach((carousel) => {
    const items = Array.from(carousel.querySelectorAll('.carousel-item'));
    if (!items.length) return;

    let activeIndex = items.findIndex((item) => item.classList.contains('active'));
    if (activeIndex < 0) activeIndex = 0;

    const update = (nextIndex) => {
      items[activeIndex]?.classList.remove('active');
      activeIndex = (nextIndex + items.length) % items.length;
      items[activeIndex]?.classList.add('active');
    };

    carousel.querySelectorAll('[data-bs-slide]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        update(activeIndex + (button.getAttribute('data-bs-slide') === 'next' ? 1 : -1));
        restart();
      });
    });

    let intervalId;

    const stop = () => {
      if (intervalId) {
        window.clearInterval(intervalId);
        intervalId = null;
      }
    };

    const restart = () => {
      stop();

      if (carousel.getAttribute('data-bs-ride') !== 'carousel') return;

      const interval = Number.parseInt(carousel.getAttribute('data-bs-interval') || '5000', 10);
      intervalId = window.setInterval(() => update(activeIndex + 1), Number.isNaN(interval) ? 5000 : interval);
    };

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', restart);
    restart();
  });
}

function initCollapses() {
  document.querySelectorAll('[data-bs-toggle="collapse"]').forEach((trigger) => {
    const targetSelector = trigger.getAttribute('data-bs-target');
    if (!targetSelector) return;

    const target = document.querySelector(targetSelector);
    if (!target) return;

    trigger.addEventListener('click', () => {
      const isOpen = target.classList.contains('show');
      const parentSelector = target.getAttribute('data-bs-parent');

      if (parentSelector) {
        const parent = document.querySelector(parentSelector);
        parent?.querySelectorAll('.collapse.show').forEach((openPanel) => {
          if (openPanel === target) return;
          openPanel.classList.remove('show');

          const openTrigger = parent.querySelector(`[data-bs-target="#${openPanel.id}"]`);
          if (openTrigger) {
            openTrigger.classList.add('collapsed');
            openTrigger.setAttribute('aria-expanded', 'false');
          }
        });
      }

      target.classList.toggle('show', !isOpen);
      trigger.classList.toggle('collapsed', isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });
}
